import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { useGameStore } from '../store/gameStore'
import { useI18n } from '../i18n/I18nProvider'
import Modal from './Modal'
import Button from './Button'
import { Save } from 'lucide-react'

function SaveProgressPrompt() {
  const { t } = useI18n()
  const [showPrompt, setShowPrompt] = useState(false)
  const user = useAuthStore((state) => state.user)
  const plants = useGameStore((state) => state.plants)
  const seedInventory = useGameStore((state) => state.seedInventory)
  const navigate = useNavigate()

  useEffect(() => {
    // Ne montrer que si l'utilisateur n'est pas connecté et a du progrès
    const totalSeeds = Object.values(seedInventory || {}).reduce((sum, qty) => sum + qty, 0)
    const hasProgress = (plants && plants.length > 0) || totalSeeds > 0

    if (user || !hasProgress) return

    const handleBeforeUnload = (e) => {
      e.preventDefault()
      e.returnValue = ''
      setShowPrompt(true)
      return ''
    }

    // Écouter la tentative de fermeture/navigation
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [user, plants, seedInventory])

  const handleSaveProgress = () => {
    navigate('/auth?mode=signup&save=true')
  }

  const handleContinueWithoutSaving = () => {
    setShowPrompt(false)
  }

  return (
    <Modal
      isOpen={showPrompt}
      onClose={handleContinueWithoutSaving}
      title={t('saveProgressPrompt.title')}
      size="sm"
    >
      <div className="text-center">
        <Save size={64} className="mx-auto text-green-600 mb-4" />
        <p className="text-gray-700 mb-2">
          {t('saveProgressPrompt.progressMade')}
        </p>
        <p className="text-gray-600 mb-6">
          {t('saveProgressPrompt.createAccountToSave')}
        </p>

        <div className="bg-green-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            <strong>{t('saveProgressPrompt.yourProgress')}</strong>
          </p>
          <ul className="text-sm text-gray-600 mt-2 space-y-1">
            {plants && plants.length > 0 && <li>✓ {t('saveProgressPrompt.growingPlant')}</li>}
            {seedInventory && Object.values(seedInventory).reduce((sum, qty) => sum + qty, 0) > 0 && (
              <li>
                ✓ {Object.values(seedInventory).reduce((sum, qty) => sum + qty, 0)}{' '}
                {t(
                  `saveProgressPrompt.seed${
                    Object.values(seedInventory).reduce((sum, qty) => sum + qty, 0) > 1
                      ? '_plural'
                      : ''
                  }`
                )}
              </li>
            )}
          </ul>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleSaveProgress}
            className="w-full"
          >
            {t('saveProgressPrompt.createAccountFree')}
          </Button>
          <Button
            onClick={handleContinueWithoutSaving}
            variant="outline"
            className="w-full"
          >
            {t('saveProgressPrompt.continueWithoutSaving')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SaveProgressPrompt
